module.exports = {
	extends: [
		'/',
		'base',
		'tableSimple',
		'table'
	],

	config: {
		isSortable: true,
		lazyloadStepSize: 25,
		// preventSortOfField: {},
		buttonContext: 'sectionComponents', // TODO: OVERWRITE FOR ROUTES
		renderEmptyBeforReady: false,
		showHead: false,
		showInsertButton: false,
		showColorCodedRows: true,
		showAllBorders: false,
		showDelimiterBorders: true,
		inline: true,
		// maxNrOfExportElements: 500000,
		// privilegeBase: 'ttgshop_products', // TODO: POI
		rowActionsProperties: {
			colWidth: '80px'
		},
		rowActions: {},
		usage: 'selection',
		isSelectionSource: true,
		isMultiSelect: false
	},

	model: {
		bulkContentBaseFilters: {},
		resourceFilters: {
			order: [{
				fieldCode: 'sort',
				direction: 'asc'
			}]
		}
	},

	methods: {

		onBuild: function(storage){
			if(storage.isClient){
				var self = this;
				self.model.bulkContentBaseFilters = self.getResourceRegisterContent('bulkContentBaseFilters') || {}
			}
		},

		sanitizeResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				var self = this;

				resourceFilters = resourceFilters || {};
				resourceFilters.baseFilters = self.model.bulkContentBaseFilters;

				resourceFilters.filters = resourceFilters.filters || {};
			}
			return resourceFilters;
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			return actionKey !== 'refreshResources' || ((resourceFilters || {}).baseFilters || {}).sectionID > 0;
		},

		addEntity: function(entity){
			// add entity to dom if possible
			if(this.config.isReady && (this.model.$table || []).length > 0){
				this.model.$table.append(this.include('./row', { config: this.config, resourceData: entity, model: this.model }));
			}
		},

		showEdit: function(rowID, rowData, buttonMode){
			if (rowID){
				if(this.toggleRowSelection(rowID, rowData)){
					this.model.layoutTrees.updateRootSectionComponentID(rowID);
				} else {
					this.model.layoutTrees.updateRootSectionComponentID(0);
				}
			}
		},

		deselectActiveNodeIfMissing: function(){
			// check if actual selected node is present after refresh (move or other operations may have happened).
			let rows = this.getSelectedRowIDs(true)
			if(!Array.isArray(rows)) rows = Object.values(rows);
			const rowID = rows[0];
			if(rowID){
				const rowData = this.getRowData(rowID) || {}
				if(!rowData.rowIsPresentInDataSet){
					// deselect row
					this.toggleRowSelection(rowID)
					this.model.layoutTrees.updateRootSectionComponentID(0);
					return true
				}
			}
			return false
		}
	},

	hooks: {
		_attach: function($element, options){
			var self = this;
			if(!self.model.layoutTrees){
				self.locate('< templates_bulk_contentController > templates_bulk_layoutTrees', function(layoutTrees){
					self.model.layoutTrees = layoutTrees
				});
			}
		},

		showEdit: function($element, options){
			const self = this;
			options = options || {};
			if(options.refreshData) {
				self.refreshData(true, { onRefreshDoneCallback: function(){
					if(options.id){
						self.showEdit(options.id, self.getRowData(options.id))
					}
				}})
			} else if(options.id) {
				self.showEdit(options.id, self.getRowData(options.id))
			}
		},

		onDelete: function($element, options){
			const self = this
			let nextRowID = -1
			let rowData;
			let rowIDs = self.getSelectedRowIDs(true)
			if(rowIDs && !Array.isArray(rowIDs)) rowIDs = Object.values(rowIDs)
			if((rowIDs || [])[0]){
				const row = self.getRowData(rowIDs[0])
				if(row.index){
					nextRowID = self.getRowIDByIndex(row.index + 1)
					rowData = self.getRowData(nextRowID)

					if(!rowData){
						nextRowID = self.getRowIDByIndex(row.index - 1)
						rowData = self.getRowData(nextRowID)
					}
				}
			}

			self.refreshData(true, { onRefreshDoneCallback: function(){
				if(self.getNrOfRows() < 1){
					self.triggerClosest('forceBySearchTerm', { searchTerm: '' }, 'templates_bulk_contentController')
				}
				if(nextRowID && rowData){
					self.showEdit(nextRowID, rowData)
				}
			}})
		}
	},
}